<template>
  <div class="items">
    <a 
      :href="equipment.url"
      data-gtmcat="equipment engagement"
      data-gtmaction="click"
      :data-gtmlabel="equipment.title | striphtml"
    >
      <img
        :src="equipment.imageUrl"
        alt=""
      >
      <div v-html="equipment.title" />
    </a>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VueLazyload from 'vue-lazyload'
 
// Vue.use(VueLazyload)

export default {
  name: "Equipment",
  components: {
    // eslint-disable-next-line
    // VueLazyload
  },
  props: {
    equipment: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => {
    return {
      debug: false,
    }
  },
  created() {
    //console.log(this.equipment)
  }
}
</script>

